const initialState = {
    featured: "All",
    searcText: "",
};
export default initialState;
